import { Injectable, computed, inject, signal } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AppRoleService } from './app-role.service';

@Injectable({
  providedIn: 'root',
})
export class DepartmentContextService {
  private readonly router = inject(Router);
  private readonly appRoleService = inject(AppRoleService);

  private readonly _departmentId = signal<string | null>(null);

  readonly departmentId = this._departmentId.asReadonly();
  readonly hasActiveDepartment = computed(() => this._departmentId() !== null);

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const url = this.router.parseUrl(this.router.url);
        const id = url.queryParams['departmentId'] ?? null;
        this._departmentId.set(typeof id === 'string' ? id : null);

        // Auto-navigate when user has exactly one Department
        const departments = this.appRoleService.assignedDepartments();
        if (departments.length === 1 && this._departmentId() !== departments[0].departmentId) {
          void this.router.navigate([], {
            queryParams: { departmentId: departments[0].departmentId },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
        }
      });
  }
}
